<section
  class="workflow-transition-editor"
  [class.workflow-transition-editor--contextual]="contextual"
  aria-labelledby="workflow-transition-editor-title"
  [attr.aria-busy]="referenceLoading ? 'true' : null"
  data-testid="workflow-draft-status-change-editor"
>
  <h4
    #transitionSectionHeading
    id="workflow-transition-editor-title"
    class="visually-hidden"
    tabindex="-1"
  >
    {{
      contextual && activeHumanStep
        ? "Step progress and labels"
        : "Workflow statuses"
    }}
  </h4>

  <ng-container *ngIf="activeHumanStep as step">
    <section [attr.data-step-statuses-overview]="stepStatusesWorkspace ? '' : null" [hidden]="stepStatusesWorkspace && stepStatusesView() !== 'overview'" class="step-statuses-overview">
      <ui-panel panelTitle="Workflow status" [noGrow]="true">
        <p>Returned, Awaiting documents and similar business states belong to the whole workflow. They stay visible when work moves between steps.</p>
        <button uiButton type="button" [disabled]="interactionBlocked || notificationEditorPending || !!lifecycleImpact()" (click)="requestWorkflowStatuses()">{{ canAuthor && !inspectionMode ? "Edit" : "View" }} workflow statuses</button>
      </ui-panel>
    </section>
    <section class="step-progress-owner" [attr.data-step-bypass-owner]="stepStatusesWorkspace && stepStatusesView() === 'bypass' ? '' : null"
      [hidden]="stepStatusesWorkspace && stepStatusesView() === 'step-labels'">
      <ng-container *ngIf="stepStatusesWorkspace && stepStatusesView() === 'bypass' && stepStatusesNavigation as navigation">
        <button uiButton type="button" [text]="true" data-back-step-bypass [disabled]="interactionBlocked" (click)="backFromStepBypass(navigation)">Back to statuses</button>
        <p *ngIf="stepStatusesMessage()" role="status">{{ stepStatusesMessage() }}</p>
      </ng-container>
      <phms-workflow-step-progress-editor data-step-progress-owner
        [document]="document" [nodeId]="step.id" [canAuthor]="canAuthor && !inspectionMode"
        [overviewMode]="stepStatusesWorkspace && stepStatusesView() !== 'bypass'" [bypassMode]="stepStatusesWorkspace && stepStatusesView() === 'bypass'"
        [latestDocument]="stepStatusesWorkspace ? currentStepStatusesDocument : null"
        [requireOwnerAcknowledgement]="stepStatusesWorkspace && requireProgressOwnerAcknowledgement"
        [ownerContext]="stepStatusesWorkspace ? ownerContext : null" [viewContext]="stepStatusesWorkspace ? viewContext : null"
        [active]="stepStatusesWorkspace ? progressOwnerActive : null" [activeView]="stepStatusesWorkspace ? progressActiveView : null"
        [activeViewState]="stepStatusesWorkspace ? progressActiveView() : undefined"
        [interactionBlocked]="interactionBlocked || (!stepStatusesWorkspace && businessStatusDirty()) || formDirty() || notificationEditorPending || !!lifecycleImpact()"
        [resetVersion]="resetVersion" [routingContracts]="routingContracts" [referenceLoading]="referenceLoading"
        (documentChange)="onBusinessStatusDocument($event)" (ownedDocumentChange)="stepStatusesWorkspace && onStepProgressOwnedChange($event)"
        (bypassDataRequested)="onBypassDataRequested($event)"
        (pendingChangesChange)="onProgressSettingsPending($event)" />
      <button *ngIf="stepStatusesWorkspace && stepStatusesView() === 'overview' && stepStatusesNavigation as navigation"
        uiButton type="button" data-open-step-bypass [disabled]="interactionBlocked || notificationEditorPending || !!lifecycleImpact()"
        (click)="configureStepBypass(navigation)">Configure bypass</button>
    </section>
    <section class="step-statuses-overview" [hidden]="stepStatusesWorkspace && stepStatusesView() !== 'overview'">
      <ui-panel *ngIf="stepStatusesWorkspace" panelTitle="Optional step labels" [noGrow]="true">
        <p>Visit-local labels describe this step alongside its fixed progress. They do not change workflow-wide statuses or complete the work.</p>
        <p>{{ stepLabelsSummary }}</p>
        <button *ngIf="stepStatusesNavigation as navigation" uiButton type="button" data-open-step-labels
          [disabled]="interactionBlocked || notificationEditorPending || !!lifecycleImpact()" (click)="configureStepLabels(navigation)">Configure step labels</button>
      </ui-panel>
    </section>
  </ng-container>

  <section [attr.data-step-labels-owner]="stepStatusesWorkspace ? '' : null" [hidden]="stepStatusesWorkspace && stepStatusesView() !== 'step-labels'" class="step-labels-owner">
    <ng-container *ngIf="stepStatusesWorkspace && stepStatusesNavigation as navigation">
      <button uiButton type="button" [text]="true" data-back-step-statuses [disabled]="interactionBlocked" (click)="backToStepStatuses(navigation)">Back to statuses</button>
      <p *ngIf="stepStatusesMessage()" role="status">{{ stepStatusesMessage() }}</p>
    </ng-container>
    <phms-workflow-status-editor [immediateChanges]="true"
      *ngIf="activeScopeDefinition?.isAuthorable && (!externalWorkflowStatuses || selectedScope().stepNodeId !== null)"
      [document]="document" [nodeId]="selectedScope().stepNodeId" [stepWorkspaceMode]="stepStatusesWorkspace"
      [latestDocument]="stepStatusesWorkspace ? currentStepStatusesDocument : null"
      [ownerContext]="stepStatusesWorkspace ? ownerContext : null" [viewContext]="stepStatusesWorkspace ? viewContext : null"
      [active]="stepStatusesWorkspace ? labelsOwnerActive : null" [activeView]="stepStatusesWorkspace ? labelsActiveView : null"
      [activeViewState]="stepStatusesWorkspace ? labelsActiveView() : undefined"
      [canAuthor]="canAuthor && !inspectionMode"
      [interactionBlocked]="interactionBlocked || (!stepStatusesWorkspace && progressSettingsDirty()) || formDirty() || notificationEditorPending || !!lifecycleImpact()"
      [resetVersion]="resetVersion" (documentChange)="onBusinessStatusDocument($event)"
      (ownedDocumentChange)="stepStatusesWorkspace && onStepLabelsOwnedChange($event)" (pendingChangesChange)="onBusinessStatusPending($event)" />
  </section>
  <p *ngIf="stepStatusesWorkspace && stepStatusesView() === 'overview' && stepStatusesMessage()" role="status">{{ stepStatusesMessage() }}</p>

  <ui-panel *ngIf="externalWorkflowStatuses && selectedScope().stepNodeId === null" panelTitle="Workflow statuses" [noGrow]="true">
    <p>Workflow labels and automatic changes are managed together in Workflow settings.</p>
    <button uiButton type="button" (click)="requestWorkflowStatuses()" [disabled]="interactionBlocked || notificationEditorPending || !!lifecycleImpact()">Manage workflow statuses</button>
  </ui-panel>

  <div
    class="workflow-transition-editor__engine-rules"
    [hidden]="stepStatusesWorkspace && stepStatusesView() !== 'overview'"
    [attr.inert]="businessStatusDirty() || progressSettingsDirty() ? '' : null"
  >
    <h5>
      {{ activeHumanStep ? "Completion checks" : "Process lifecycle checks" }}
    </h5>
    <p>
      These rules control whether the process can start or a step can complete.
      Workflow business statuses and optional step labels are configured
      separately above.
    </p>
    <p *ngIf="hasUnsupportedProgressRules" role="alert">
      This step has retained lifecycle entries that cannot be used with standard
      step progress. Inspect and remove those entries before publishing.
      Starting, assignment and bypass are managed by their dedicated settings;
      completion checks use In progress → Completed.
    </p>

    <p
      *ngIf="!inspectionMode && referenceLoading"
      class="workflow-transition-editor__state"
      role="status"
      aria-live="polite"
    >
      Loading active status choices. Saved status changes remain available to
      inspect.
    </p>

    <div
      *ngIf="!inspectionMode && referenceError as error"
      class="workflow-transition-editor__error"
      role="alert"
      aria-live="assertive"
    >
      <div>
        <strong>{{ error.title }}</strong>
        <ul>
          <li *ngFor="let message of error.messages">{{ message }}</li>
        </ul>
        <p *ngIf="referenceDataReady">
          The last successfully loaded status choices remain available for
          authoring.
        </p>
        <p *ngIf="!referenceDataReady">
          Saved status changes remain available to inspect, but authoring is
          unavailable.
        </p>
      </div>
      <button
        uiButton
        [text]="true"
        [outlined]="false"
        type="button"
        class="workflow-transition-editor__text-button"
        [disabled]="referenceLoading"
        (click)="retryReferencesRequested.emit()"
      >
        Retry status choices
      </button>
    </div>

    <p
      *ngIf="
        !inspectionMode &&
        !referenceLoading &&
        !referenceDataReady &&
        !referenceError
      "
      class="workflow-transition-editor__state"
      role="status"
    >
      No active status choices are available. Saved status changes remain
      inspectable, but authoring is disabled.
    </p>

    <p
      *ngIf="(hasOpaqueTransitionCollections ? opaqueCollectionMessage : statusMessage()) as message"
      class="workflow-transition-editor__notice"
      role="status"
      aria-live="polite"
    >
      {{ message }}
    </p>

    <div
      *ngIf="localError() as error"
      #transitionError
      class="workflow-transition-editor__error workflow-transition-editor__error--local"
      role="alert"
      aria-live="assertive"
      tabindex="-1"
    >
      {{ error }}
      <button
        uiButton
        *ngIf="formDirty() && !isAddingTransition() && !selectedRow"
        type="button"
        [disabled]="interactionBlocked"
        (click)="discardMainFormChanges()"
      >
        Reset form
      </button>
    </div>

    <section
      *ngIf="activeHumanStep as step"
      class="workflow-transition-editor__lifecycle"
      aria-labelledby="workflow-step-lifecycle-title"
      data-testid="effective-step-lifecycle"
    >
      <header class="workflow-transition-editor__effective-header">
        <h5
          #effectiveLifecycleHeading
          id="workflow-step-lifecycle-title"
          tabindex="-1"
        >
          Effective step behavior
        </h5>
        <span class="workflow-transition-editor__lifecycle-badge">{{
          activeLifecycleUnavailable ? "Saved lifecycle unavailable" : usesDefaultLifecycle
            ? "Platform default lifecycle"
            : "Explicit lifecycle rules"
        }}</span>
      </header>
      <dl class="workflow-transition-editor__effective-behavior">
        <div>
          <dt>Starting the step</dt>
          <dd>
            <strong>{{
              step.stepProgressConfiguration
                ? "Pending / Assigned → In progress"
                : "Automatic → In progress (existing behavior)"
            }}</strong>
          </dd>
        </div>
        <div>
          <dt>Completing the step</dt>
          <dd>
            <strong>{{
              activeLifecycleUnavailable ? "Cannot determine completion availability" : completionAllowed
                ? "Completion action available"
                : "Completion action unavailable"
            }}</strong>
          </dd>
          <dd>
            {{
              activeLifecycleUnavailable ? "The retained lifecycle collection cannot be inspected." : completionAllowed
                ? "In progress → Completed"
                : "No explicit In progress → Completed rule is saved."
            }}
          </dd>
        </div>
      </dl>
      <p class="workflow-transition-editor__hint">
        {{
          activeLifecycleUnavailable ? "The saved lifecycle collection is unavailable. Its original configuration is preserved." : usesDefaultLifecycle
            ? "Platform defaults apply because no explicit rules are saved."
            : "Saved explicit rules replace the platform defaults."
        }}
        Availability describes the status change; requirements and decision
        checks must still pass.
      </p>
      <section
        class="workflow-transition-editor__effective-checks"
        aria-labelledby="workflow-effective-checks-title"
      >
        <h6 id="workflow-effective-checks-title">Additional decision checks</h6>
        <p *ngIf="completionDecisionCountsUnavailable">
          Saved decision-check collections are unavailable; counts cannot be established. Their original content is preserved.
        </p>
        <p *ngIf="completionAllowed && !completionDecisionCountsUnavailable">
          {{ completionDecisionCount }} distinct check{{
            completionDecisionCount === 1 ? "" : "s"
          }}
          on completion: {{ stepDecisionCount() }} step-wide and
          {{ transitionDecisionCount(completionRow?.transition || null) }} on
          this status change. Shared checks are counted once.
        </p>
        <p *ngIf="!completionAllowed && !completionDecisionCountsUnavailable">
          {{ stepDecisionCount() }} step-wide check{{
            stepDecisionCount() === 1 ? " is" : "s are"
          }}
          saved. Completion needs an explicit completion rule before these
          checks can apply to that action.
        </p>
        <div class="workflow-transition-editor__summary-actions">
          <button
            uiButton
            [text]="true"
            [outlined]="false"
            type="button"
            class="workflow-transition-editor__link-button"
            [disabled]="
              interactionBlocked ||
              notificationEditorPending ||
              !!lifecycleImpact()
            "
            (click)="requestStepDecisionRules()"
          >
            Review step-wide checks
          </button>
          <button
            uiButton
            [text]="true"
            [outlined]="false"
            *ngIf="completionRow"
            type="button"
            class="workflow-transition-editor__link-button"
            [disabled]="
              interactionBlocked ||
              notificationEditorPending ||
              !!lifecycleImpact()
            "
            (click)="requestCompletionDecisionRules()"
          >
            Review completion checks
          </button>
        </div>
      </section>
      <p class="workflow-transition-editor__requirements-handoff">
        Fresh files, form answers and decisions are configured in
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          class="workflow-transition-editor__link-button"
          [disabled]="
            interactionBlocked ||
            notificationEditorPending ||
            !!lifecycleImpact()
          "
          (click)="requestCompletionRequirements()"
        >
          Completion requirements</button
        >.
      </p>
    </section>

    <section
      *ngIf="lifecycleImpact() as impact"
      class="workflow-transition-editor__impact"
      aria-labelledby="workflow-lifecycle-impact-title"
      data-testid="lifecycle-impact-preview"
    >
      <h5
        #lifecycleImpactHeading
        id="workflow-lifecycle-impact-title"
        tabindex="-1"
      >
        {{
          impact.operation === "add"
            ? "Review adding a completion rule"
            : "Review removing this status rule"
        }}
      </h5>
      <dl>
        <div>
          <dt>Before</dt>
          <dd>{{ impact.before }}</dd>
        </div>
        <div>
          <dt>After</dt>
          <dd>{{ impact.after }}</dd>
        </div>
      </dl>
      <p *ngIf="impact.operation === 'add'">
        The new completion rule starts with no decision checks or notification
        recipients of its own. Step-wide checks and Completion requirements
        remain in place.
      </p>
      <p *ngIf="impact.operation === 'remove'">
        This also removes {{ impact.attachedDecisionCount }} attached decision
        check{{ impact.attachedDecisionCount === 1 ? "" : "s" }} and
        {{ impact.attachedNotificationCount }} notification recipient{{
          impact.attachedNotificationCount === 1 ? "" : "s"
        }}. Step-wide checks and Completion requirements remain in place.
      </p>
      <p *ngIf="impact.operation === 'remove' && impact.attachedMessageCount">
        This removes {{ impact.attachedMessageCount }} attached notification
        message{{ impact.attachedMessageCount === 1 ? "" : "s" }}, including
        their title, body and context settings.
      </p>
      <p>
        Apply changes the working draft locally. Save draft keeps the applied
        change. Cancel leaves the working draft unchanged.
      </p>
      <p *ngIf="!canApplyLifecycleImpact" role="status">
        The step or authoring access changed. Cancel this preview and review the
        current rules.
      </p>
      <div class="workflow-transition-editor__summary-actions">
        <button
          uiButton
          severity="primary"
          [outlined]="false"
          type="button"
          class="workflow-transition-editor__primary-action"
          [disabled]="!canApplyLifecycleImpact"
          (click)="applyLifecycleImpact()"
        >
          Apply change
        </button>
        <button
          uiButton
          [text]="true"
          [outlined]="false"
          type="button"
          class="workflow-transition-editor__text-button"
          [disabled]="interactionBlocked"
          (click)="cancelLifecycleImpact()"
        >
          Cancel change
        </button>
      </div>
    </section>

    <details
      *ngIf="contextual && activeHumanStep; else expandedStatusWorkspace"
      class="workflow-transition-editor__customization"
      [open]="customizationExpanded()"
      (toggle)="customizationExpanded.set($any($event.target).open)"
    >
      <summary>
        Lifecycle customization and retained rules
        <span
          *ngIf="!activeLifecycleUnavailable"
          >{{ activeRows.length }} saved rule{{
            activeRows.length === 1 ? "" : "s"
          }}</span
        >
        <span *ngIf="activeLifecycleUnavailable">Saved rule count unavailable</span>
      </summary>
      <p class="workflow-transition-editor__customization-copy">
        The completion action uses In progress → Completed. Other saved pairs
        remain inspectable; they do not provide additional staff actions. Adding
        the first explicit rule replaces platform defaults; removing the last
        restores them.
      </p>
      <ng-container *ngTemplateOutlet="statusWorkspace"></ng-container>
    </details>
    <ng-template #expandedStatusWorkspace
      ><ng-container *ngTemplateOutlet="statusWorkspace"></ng-container
    ></ng-template>
    <ng-template #statusWorkspace>
      <div
        class="workflow-transition-editor__workspace"
        data-testid="status-change-three-column-workspace"
      >
        <nav
          class="workflow-transition-editor__scopes"
          [hidden]="contextual"
          aria-labelledby="workflow-transition-scope-title"
          data-testid="status-change-scope-rail"
        >
          <header class="workflow-transition-editor__column-header">
            <h5 id="workflow-transition-scope-title">Where rules apply</h5>
          </header>

          <button
            [wrap]="true"
            uiButton
            [text]="true"
            [outlined]="false"
            *ngIf="scopes[0] as workflowScope"
            type="button"
            class="workflow-transition-editor__scope-button"
            [class.workflow-transition-editor__scope-button--selected]="
              workflowScope.key === selectedScopeKey
            "
            [attr.aria-pressed]="workflowScope.key === selectedScopeKey"
            [disabled]="interactionBlocked || notificationEditorPending"
            (click)="selectScope(workflowScope, $event.detail === 0)"
          >
            <span>
              <strong>{{ workflowScope.label }}</strong>
              <small>{{ workflowScope.detail }}</small>
            </span>
            <span *ngIf="!scopeCollectionOpaque(workflowScope)" class="workflow-transition-editor__scope-count">
              {{ workflowScope.transitionCount }}
              change{{ workflowScope.transitionCount === 1 ? "" : "s" }}
            </span>
            <span *ngIf="scopeCollectionOpaque(workflowScope)" class="workflow-transition-editor__scope-count">Saved rules unavailable</span>
          </button>

          <h6
            *ngIf="workStepScopes.length > 0"
            class="workflow-transition-editor__scope-divider"
          >
            Work steps
          </h6>
          <button
            [wrap]="true"
            uiButton
            [text]="true"
            [outlined]="false"
            *ngFor="let scope of workStepScopes; trackBy: trackTransitionScope"
            type="button"
            class="workflow-transition-editor__scope-button"
            [class.workflow-transition-editor__scope-button--selected]="
              scope.key === selectedScopeKey
            "
            [attr.aria-pressed]="scope.key === selectedScopeKey"
            [disabled]="interactionBlocked || notificationEditorPending"
            (click)="selectScope(scope, $event.detail === 0)"
          >
            <span>
              <strong>{{ scope.label }}</strong>
              <small *ngIf="scope.decisionRuleCount > 0">
                {{ scope.decisionRuleCount }}
                decision rule{{ scope.decisionRuleCount === 1 ? "" : "s" }}
              </small>
            </span>
            <span class="workflow-transition-editor__scope-count">
              {{
                scopeCollectionOpaque(scope) ? "Saved rules unavailable" : scope.transitionCount === 0
                  ? "Default lifecycle"
                  : scope.transitionCount +
                    " explicit rule" +
                    (scope.transitionCount === 1 ? "" : "s")
              }}
            </span>
          </button>

          <h6
            *ngIf="evidenceScopes.length > 0"
            class="workflow-transition-editor__scope-divider"
          >
            {{
              inspectionMode ? "Other saved evidence" : "Other draft evidence"
            }}
          </h6>
          <button
            [wrap]="true"
            uiButton
            [text]="true"
            [outlined]="false"
            *ngFor="let scope of evidenceScopes; trackBy: trackTransitionScope"
            type="button"
            class="workflow-transition-editor__scope-button"
            [class.workflow-transition-editor__scope-button--selected]="
              scope.key === selectedScopeKey
            "
            [attr.aria-pressed]="scope.key === selectedScopeKey"
            [disabled]="interactionBlocked || notificationEditorPending"
            (click)="selectScope(scope, $event.detail === 0)"
          >
            <span>
              <strong>{{ scope.label }}</strong>
              <small>{{ scope.detail }}</small>
            </span>
            <span *ngIf="!scopeCollectionOpaque(scope)" class="workflow-transition-editor__scope-count">
              {{ scope.transitionCount }}
              change{{ scope.transitionCount === 1 ? "" : "s" }}
            </span>
            <span *ngIf="scopeCollectionOpaque(scope)" class="workflow-transition-editor__scope-count">Saved rules unavailable</span>
          </button>
        </nav>

        <section
          class="workflow-transition-editor__navigator"
          aria-labelledby="workflow-transition-list-title"
          data-testid="status-change-navigator"
        >
          <header class="workflow-transition-editor__column-header">
            <div>
              <h5 id="workflow-transition-list-title">
                {{
                  activeHumanStep
                    ? "Saved lifecycle rules"
                    : "Allowed status changes"
                }}
              </h5>
              <span *ngIf="!activeLifecycleUnavailable" aria-live="polite">
                {{ activeRows.length }} explicit rule{{
                  activeRows.length === 1 ? "" : "s"
                }}
              </span>
              <span *ngIf="activeLifecycleUnavailable" aria-live="polite">Saved rule count unavailable</span>
            </div>
            <button
              uiButton
              severity="primary"
              [outlined]="false"
              *ngIf="canAuthor"
              type="button"
              class="workflow-transition-editor__primary-action"
              data-testid="add-workflow-transition"
              [attr.aria-label]="
                activeHumanStep ? 'Add completion rule' : 'Add status change'
              "
              [disabled]="
                interactionBlocked ||
                notificationEditorPending ||
                referenceLoading ||
                !referenceDataReady ||
                !activeScopeDefinition?.isAuthorable ||
                !!lifecycleImpact() ||
                (activeHumanStep && !canAddCompletionRule)
              "
              [attr.aria-disabled]="
                !activeScopeDefinition?.isAuthorable ? 'true' : null
              "
              (click)="beginAddTransition($event.detail === 0)"
            >
              {{
                activeHumanStep ? "Add completion rule" : "Add status change"
              }}
            </button>
          </header>

          <p
            *ngIf="activeLifecycleUnavailable"
            class="workflow-transition-editor__empty"
          >The saved lifecycle rules are unavailable. Their number and behavior cannot be inferred.</p>
          <p
            *ngIf="activeRows.length === 0 && !activeLifecycleUnavailable"
            class="workflow-transition-editor__empty"
          >
            {{
              activeHumanStep
                ? "No explicit rules. Platform defaults apply; the completion action is available."
                : "No explicit status changes are defined for this scope."
            }}
          </p>

          <div
            *ngIf="activeRows.length > 0"
            class="workflow-transition-editor__change-list"
          >
            <button
              [wrap]="true"
              uiButton
              [text]="true"
              [outlined]="false"
              *ngFor="let row of activeRows; trackBy: trackTransitionRow"
              type="button"
              class="workflow-transition-editor__change-button"
              [class.workflow-transition-editor__change-button--selected]="
                row.key === selectedKey
              "
              [attr.aria-current]="row.key === selectedKey ? 'true' : null"
              [attr.aria-label]="transitionAriaLabel(row)"
              [disabled]="
                interactionBlocked ||
                notificationEditorPending ||
                !!lifecycleImpact()
              "
              (click)="reviewTransition(row, $event.detail === 0)"
            >
              <ng-container
                *ngIf="row.transition as transition; else invalidTransition"
              >
                <span class="workflow-transition-editor__change-flow">
                  <strong>{{ stateLabel(transition.fromStateCode) }}</strong>
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                  <strong>{{ stateLabel(transition.toStateCode) }}</strong>
                </span>
                <span
                  *ngIf="effectiveDecisionCount(transition) as decisionCount"
                  class="workflow-transition-editor__decision-count"
                >
                  {{ decisionCount }}
                  total {{ activeHumanStep ? "decision check" : "requirement"
                  }}{{ decisionCount === 1 ? "" : "s" }}
                </span>
                <span
                  *ngIf="activeHumanStep"
                  class="workflow-transition-editor__applicability"
                >
                  {{ transitionApplicability(row) }}
                </span>
              </ng-container>
              <ng-template #invalidTransition>
                <span class="workflow-transition-editor__change-flow">
                  <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
                  <strong>Invalid status-change entry</strong>
                </span>
                <span class="workflow-transition-editor__decision-count">
                  Entry {{ row.index + 1 }}
                </span>
              </ng-template>
              <span *ngIf="row.key === selectedKey" class="visually-hidden"
                >Selected</span
              >
            </button>
          </div>
        </section>

        <section
          class="workflow-transition-editor__inspector"
          aria-labelledby="workflow-transition-form-title"
          data-testid="status-change-inspector"
        >
          <header class="workflow-transition-editor__inspector-header">
            <h5
              #transitionEditorHeading
              id="workflow-transition-form-title"
              tabindex="-1"
            >
              <ng-container
                *ngIf="isAddingTransition(); else selectedInspectorTitle"
              >
                Add a status change
              </ng-container>
              <ng-template #selectedInspectorTitle>
                <ng-container
                  *ngIf="
                    selectedRow?.transition as transition;
                    else noValidSelection
                  "
                >
                  {{ stateLabel(transition.fromStateCode) }}
                  <i class="pi pi-arrow-right" aria-hidden="true"></i>
                  {{ stateLabel(transition.toStateCode) }}
                </ng-container>
                <ng-template #noValidSelection>
                  {{
                    selectedRow
                      ? "Invalid status-change entry"
                      : activeLifecycleUnavailable
                        ? "Saved lifecycle unavailable"
                        : activeHumanStep
                          ? "Default completion"
                          : "Choose a status change"
                  }}
                </ng-template>
              </ng-template>
            </h5>
            <p *ngIf="!contextual">
              {{ activeScopeDefinition?.label || "Status changes" }}
            </p>
          </header>

          <p
            *ngIf="!isAddingTransition() && !selectedRow"
            class="workflow-transition-editor__inspector-empty"
          >
            {{
              activeLifecycleUnavailable
                ? "The saved lifecycle rules cannot be inspected. Their original configuration is preserved; authoring is read-only."
                : activeHumanStep
                  ? inspectionMode
                    ? "In progress → Completed uses the platform defaults. This immutable version has no explicit override."
                    : "Add a completion rule when this event needs its own requirements."
                  : inspectionMode
                    ? "Select a saved status change to inspect it."
                    : "Select a saved status change to inspect it, or add one for this scope."
            }}
          </p>

          <div
            *ngIf="
              !isAddingTransition() &&
              selectedRow &&
              selectedRow?.transition === null
            "
            class="workflow-transition-editor__invalid-entry"
          >
            <strong>This saved entry is malformed.</strong>
            <p>
              Its array position is preserved so server validation can identify
              it.
              <ng-container *ngIf="!inspectionMode">
                Remove the entry explicitly when you are ready to repair this
                draft.
              </ng-container>
            </p>
          </div>

          <ng-container *ngIf="isAddingTransition() || selectedRow?.transition">
            <p
              *ngIf="
                activeScopeDefinition?.isAuthorable && !activeHumanStep;
                else validationEvidenceCopy
              "
              [hidden]="contextual"
              class="workflow-transition-editor__inspector-copy"
            >
              <ng-container
                *ngIf="inspectionMode; else authoringTransitionCopy"
              >
                This saved rule allows
                {{ activeScopeDefinition?.detail | lowercase }} to move between
                these two statuses. The selected version is immutable.
              </ng-container>
              <ng-template #authoringTransitionCopy>
                This rule allows
                {{ activeScopeDefinition?.detail | lowercase }} to move between
                these two statuses. Save draft includes this form, or you can
                apply it locally first.
              </ng-template>
            </p>
            <ng-template #validationEvidenceCopy>
              <p
                *ngIf="!activeHumanStep"
                class="workflow-transition-editor__inspector-copy"
              >
                <ng-container
                  *ngIf="inspectionMode; else authorableValidationEvidenceCopy"
                >
                  This saved status-change entry is attached to a node that is
                  not a work step. It remains visible as immutable validation
                  evidence.
                </ng-container>
                <ng-template #authorableValidationEvidenceCopy>
                  This saved status-change entry is attached to a node that is
                  not a work step. It remains available as validation evidence
                  and can be removed by an authorized author, but status changes
                  cannot be authored at this location.
                </ng-template>
              </p>
            </ng-template>

            <section
              class="workflow-transition-editor__inspector-section"
              aria-labelledby="workflow-transition-details-title"
            >
              <h6 id="workflow-transition-details-title">
                {{
                  activeHumanStep
                    ? "Status rule details"
                    : "Status change details"
                }}
              </h6>
              <p
                *ngIf="activeHumanStep && selectedRow?.transition as transition"
              >
                <strong
                  >{{ stateLabel(transition.fromStateCode) }} →
                  {{ stateLabel(transition.toStateCode) }}</strong
                >
                {{
                  selectedIsEffectiveCompletion
                    ? "is the supported work-step completion event. Edit decision checks here."
                    : isCompletionTransition(transition)
                      ? "is a retained duplicate. Completion uses the first matching saved rule. You can inspect this entry or remove it."
                      : "is retained saved configuration. The current work-step action does not execute this pair. You can inspect its attached rules or remove it."
                }}
              </p>
              <p
                *ngIf="!canAuthor && activeScopeDefinition?.isAuthorable"
                class="workflow-transition-editor__hint"
              >
                {{
                  inspectionMode
                    ? "This status change belongs to an immutable workflow version."
                    : "You can inspect this status change. Author permission is required to change it."
                }}
              </p>
              <ui-form
                *ngIf="!activeHumanStep"
                #transitionForm
                instanceId="workflow-draft-status-change-form"
                aria-label="Status change details"
                [config]="transitionFormConfig"
                [(formValues)]="transitionFormValues"
                [disabled]="
                  !canAuthor ||
                  interactionBlocked ||
                  referenceLoading ||
                  !referenceDataReady ||
                  !activeScopeDefinition?.isAuthorable
                "
                (formValuesChange)="onFormChange($event)"
              ></ui-form>
              <p
                *ngIf="formDirty()"
                class="workflow-transition-editor__pending"
                role="status"
              >
                <strong>Save draft</strong> includes these status-change edits.
                You can also apply them locally before saving.
              </p>
            </section>
          </ng-container>

          <section
            *ngIf="
              !isAddingTransition() && selectedRow?.transition as transition
            "
            class="workflow-transition-editor__inspector-section"
            aria-labelledby="workflow-transition-decisions-title"
          >
            <h6 id="workflow-transition-decisions-title">
              {{
                activeHumanStep ? "Decision checks" : "Decision requirements"
              }}
            </h6>
            <p *ngIf="effectiveDecisionCollectionsOpaque(transition)">
              Saved decision-check collections are unavailable; counts cannot be established. Their original content is preserved.
            </p>
            <p
              *ngIf="
                !effectiveDecisionCollectionsOpaque(transition) &&
                effectiveDecisionCount(transition) === 0 &&
                activeScopeDefinition?.isAuthorable
              "
            >
              No decision {{ activeHumanStep ? "checks" : "requirements" }} are
              configured for this event.
            </p>
            <p
              *ngIf="
                !decisionCollectionsOpaque(transition) &&
                transitionDecisionCount(transition) === 0 &&
                !activeScopeDefinition?.isAuthorable
              "
            >
              No decision metadata is attached to this validation evidence.
            </p>
            <p
              *ngIf="
                !effectiveDecisionCollectionsOpaque(transition) &&
                effectiveDecisionCount(transition) > 0 &&
                activeScopeDefinition?.isAuthorable
              "
            >
              {{ effectiveDecisionCount(transition) }} distinct decision
              {{ activeHumanStep ? "check" : "requirement"
              }}{{ effectiveDecisionCount(transition) === 1 ? "" : "s" }}:
              {{ ownerDecisionCount() }}
              {{
                selectedScope().scopeCode === "workflow"
                  ? "workflow-wide"
                  : "step-wide"
              }}
              and {{ transitionDecisionCount(transition) }} local to this event.
              Shared {{ activeHumanStep ? "checks" : "requirements" }} are
              counted once.
              <ng-container
                *ngIf="activeHumanStep && !selectedIsEffectiveCompletion"
              >
                These are retained configuration; the current completion action
                does not use this saved entry.
              </ng-container>
            </p>
            <p
              *ngIf="
                !decisionCollectionsOpaque(transition) &&
                transitionDecisionCount(transition) > 0 &&
                !activeScopeDefinition?.isAuthorable
              "
            >
              {{ transitionDecisionCount(transition) }}
              decision rule{{
                transitionDecisionCount(transition) === 1 ? "" : "s"
              }}
              {{ transitionDecisionCount(transition) === 1 ? "is" : "are" }}
              attached to this validation evidence.
            </p>
            <button
              uiButton
              [text]="true"
              [outlined]="false"
              type="button"
              class="workflow-transition-editor__link-button"
              [disabled]="
                interactionBlocked ||
                notificationEditorPending ||
                (!!activeHumanStep?.stepProgressConfiguration &&
                  !isCompletionTransition(transition))
              "
              (click)="requestDecisionRules()"
            >
              {{
                activeHumanStep
                  ? "Review decision checks"
                  : "Open decision requirements"
              }}
            </button>
          </section>

          <section
            *ngIf="
              !isAddingTransition() &&
              (selectedRow?.transition?.notifications?.length ||
                selectedRow?.transition?.notificationMessage) &&
              selectedRow?.transition as transition
            "
            class="workflow-transition-editor__inspector-section"
            aria-labelledby="workflow-transition-notifications-title"
            data-testid="status-notification-summary"
          >
            <h6 id="workflow-transition-notifications-title">
              Saved notifications
            </h6>
            <p>
              {{ notificationCount(transition) }} recipient{{
                notificationCount(transition) === 1 ? "" : "s"
              }}
              configured after this event.
            </p>
            <ul
              *ngIf="(transition.notifications?.length || 0) > 0"
              class="workflow-transition-editor__recipient-summary"
            >
              <li *ngFor="let rule of transition.notifications">
                {{
                  rule
                    ? stateLabel(rule.recipientTypeCode)
                    : "Invalid recipient entry retained for repair"
                }}
                <ng-container *ngIf="rule?.recipientTargetKey"
                  >: {{ stateLabel(rule?.recipientTargetKey) }}</ng-container
                >
                <ng-container *ngIf="rule">
                  · {{ stateLabel(rule.severityCode) }}</ng-container
                >
              </li>
            </ul>
            <p class="workflow-transition-editor__delivery-note">
              Configuration only · Notification delivery is not implemented.
            </p>
            <button
              uiButton
              [wrap]="true"
              [text]="true"
              [outlined]="false"
              *ngIf="selectedScope().scopeCode === 'step'"
              type="button"
              class="workflow-transition-editor__link-button"
              [disabled]="interactionBlocked || notificationEditorPending"
              (click)="requestNotifications()"
            >
              Inspect saved notifications
            </button>
            <p
              *ngIf="selectedScope().scopeCode === 'workflow'"
              class="workflow-transition-editor__hint"
            >
              Whole-workflow recipients are retained for inspection.
            </p>
          </section>

          <details
            *ngIf="isAddingTransition() || selectedRow?.transition"
            class="workflow-transition-editor__technical"
          >
            <summary>Technical codes</summary>
            <dl>
              <div>
                <dt>Scope code</dt>
                <dd>
                  <code>{{ selectedScope().scopeCode }}</code>
                </dd>
              </div>
              <div *ngIf="selectedScope().stepNodeId">
                <dt>Step node ID</dt>
                <dd>
                  <code>{{ selectedScope().stepNodeId }}</code>
                </dd>
              </div>
              <div>
                <dt>Current status code</dt>
                <dd>
                  <code>{{ transitionFormValues.fromStateCode }}</code>
                </dd>
              </div>
              <div>
                <dt>Next status code</dt>
                <dd>
                  <code>{{ transitionFormValues.toStateCode }}</code>
                </dd>
              </div>
            </dl>
          </details>

          <details
            *ngIf="
              !isAddingTransition() &&
              selectedRow &&
              selectedRow?.transition === null
            "
            class="workflow-transition-editor__technical"
          >
            <summary>Technical location</summary>
            <dl>
              <div>
                <dt>Scope code</dt>
                <dd>
                  <code>{{ selectedScope().scopeCode }}</code>
                </dd>
              </div>
              <div *ngIf="selectedScope().stepNodeId">
                <dt>Step node ID</dt>
                <dd>
                  <code>{{ selectedScope().stepNodeId }}</code>
                </dd>
              </div>
              <div>
                <dt>Array position</dt>
                <dd>
                  <code>{{ (selectedTransition()?.index || 0) + 1 }}</code>
                </dd>
              </div>
            </dl>
          </details>

          <div
            *ngIf="canAuthor && (isAddingTransition() || selectedRow)"
            class="workflow-transition-editor__editor-actions"
            role="group"
            aria-label="Status change editor actions"
          >
            <button
              uiButton
              severity="primary"
              [outlined]="false"
              *ngIf="!actionButtons[0].hidden"
              type="button"
              class="workflow-transition-editor__primary-action"
              [disabled]="actionButtons[0].disabled"
              (click)="onActionButtonClick(actionButtons[0])"
            >
              {{ actionButtons[0].buttonText }}
            </button>
            <button
              uiButton
              *ngIf="!actionButtons[1].hidden"
              type="button"
              [disabled]="actionButtons[1].disabled"
              (click)="onActionButtonClick(actionButtons[1])"
            >
              {{ actionButtons[1].buttonText }}
            </button>
            <button
              uiButton
              *ngIf="!actionButtons[2].hidden"
              type="button"
              [disabled]="actionButtons[2].disabled"
              (click)="onActionButtonClick(actionButtons[2])"
            >
              {{ actionButtons[2].buttonText }}
            </button>
          </div>
        </section>
      </div>
    </ng-template>
  </div>
</section>
